// extracted by mini-css-extract-plugin
export var csatScore = "_mg-5";
export var header = "_mg-1";
export var panelWrapper = "_mg-2";
export var postPreview = "_mg-3";
export var rightContent = "_mg-0";
export var wrappingText = "_mg-4";